import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../mobile.css';

const MobileStatementDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const statement = location.state?.statement;

  if (!statement) return <p style={{ textAlign: 'center', fontWeight: 700 }}>No statement selected.</p>;

  const buttons = [
    {
      title: 'Timeline',
      onClick: () => navigate('/m/fir/timeline', { state: { fir: { eventsAndTimeline: statement.eventsAndTimeline } } }),
    },
    {
      title: 'Tasks',
      onClick: () => navigate('/m/fir/tasks', { state: { fir: { urgentTasks: statement.urgentTasks }, statement: true } }),
    },
    {
      title: 'Evidence',
      onClick: () => navigate('/m/fir/evidences', {
        state: {
          fir: {
            evidenceList: statement.evidenceList,
            evidenceStatus: statement.evidenceStatus,
            evidenceSource: statement.evidenceSource,
            evidenceCategory: statement.evidenceCategory,
          },
          statement: true,
        },
      }),
    },
    {
      title: 'Witnesses',
      onClick: () => navigate('/m/fir/witnesses', { state: { fir: statement, statement: true } }),
    },
    {
      title: 'Accused',
      onClick: () => navigate('/m/fir/accused', { state: { fir: statement, statement: true } }),
    },
    {
      title: 'Questions',
      onClick: () => navigate('/m/fir/witnesses/questions', {
        state: { name: statement.respondent, interrogationQuestions: statement.interrogationQuestions || [], statement: true },
      }),
    },
  ];

  return (
    <div>
      <h2 style={{ fontSize: '18px', fontWeight: 700, color: '#094268', marginBottom: '15px' }}>{statement.respondent}'s Statement</h2>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        {buttons.map(({ title, onClick }) => (
          <button
            key={title}
            onClick={onClick}
            className="m-card"
            style={{ border: '1px solid #094268', textAlign: 'center', fontWeight: 600, color: '#094268', cursor: 'pointer' }}
          >
            {title}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileStatementDashboard;
